import { render, staticRenderFns } from "./copyrightContainer.vue?vue&type=template&id=49778938&scoped=true"
import script from "./copyrightContainer.vue?vue&type=script&lang=js"
export * from "./copyrightContainer.vue?vue&type=script&lang=js"
import style0 from "./copyrightContainer.vue?vue&type=style&index=0&id=49778938&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49778938",
  null
  
)

export default component.exports